var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { alias, disgardOldValue, object } from '../../utils/serializr/serializr';
import { Question } from '../../classes/question/Question';
import { QuestionTypeName } from '../../classes/learnware/LearnwareEnums';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { primitive } from '../../utils/serializr/schema/inner/primitive';
import { SortableStore } from './modules/SortableStore';
import { withInit } from '../../utils/serializr/schema/middle/withInit';
import { SortableEdit } from './modules/SortableEdit';
import { SortableEvents } from './modules/SortableEvents';
import { SortableCheck } from './modules/SortableCheck';
import { SortableMoves } from './modules/SortableMoves';
import { SortableLists } from './modules/SortableLists';
import { SortableExtractState } from './modules/SortableExtractState';
import { SortableUI } from './modules/SortableUI';
import { SortableScore } from './modules/SortableScore';
import { editable } from '../../utils/mobx/decorators/editable';
export class QuestionSortable extends Question {
    questionType = QuestionTypeName.Sortable;
    sortableStore;
    get exportingChildren() {
        return [...super.exportingChildren, ...this.sortableStore.sortableItems, ...this.sortableStore.sortableLists]; // importing nodes
    }
    get questionScore() {
        return new SortableScore(this);
    }
    get sortableEdit() {
        return new SortableEdit(this);
    }
    get sortableEvents() {
        return new SortableEvents(this);
    }
    get sortableLists() {
        return new SortableLists(this);
    }
    get sortableCheck() {
        return new SortableCheck(this);
    }
    get sortableMoves() {
        return new SortableMoves(this);
    }
    get sortableExtractState() {
        return new SortableExtractState(this);
    }
    get sortableUI() {
        return new SortableUI(this);
    }
    static get serializeInfo() {
        return {
            extends: Question.serializeInfo,
            props: {
                questionType: withInit(primitive, QuestionTypeName.Sortable),
                sortableStore: alias('questionTypeStore', withInit(object(SortableStore), {})),
                textBasis: alias('text', disgardOldValue(primitive)),
            },
        };
    }
}
__decorate([
    editable()
], QuestionSortable.prototype, "questionType", void 0);
__decorate([
    memoize
], QuestionSortable.prototype, "questionScore", null);
__decorate([
    memoize
], QuestionSortable.prototype, "sortableEdit", null);
__decorate([
    memoize
], QuestionSortable.prototype, "sortableEvents", null);
__decorate([
    memoize
], QuestionSortable.prototype, "sortableLists", null);
__decorate([
    memoize
], QuestionSortable.prototype, "sortableCheck", null);
__decorate([
    memoize
], QuestionSortable.prototype, "sortableMoves", null);
__decorate([
    memoize
], QuestionSortable.prototype, "sortableExtractState", null);
__decorate([
    memoize
], QuestionSortable.prototype, "sortableUI", null);
__decorate([
    memoize
], QuestionSortable, "serializeInfo", null);
